// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.badge-primary {\n  color: white !important;\n  background-color: #37514d !important;\n}\n.tab-selected {\n  color: #19191c !important;\n}\n.tab-unselected {\n  color: #828282 !important;\n}\n.background {\n  position: fixed;\n  display: none;\n  transition: background-color 1s cubic-bezier(0.455, 0.03, 0.515, 0.955);\n  background-color: rgba(12, 53, 35, 0);\n  transition-delay: 0.3s;\n  height: 100vh;\n  width: 100vw;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 599;\n}\n", ""]);
// Exports
module.exports = exports;
